/*
 * Custom Filter Adjustments
 *
 * This script tweaks the storefront facet filters client‑side. It renames
 * the default “Brand” filter (which comes from the product vendor) to
 * “Wheel Brand” and sorts each filter’s values alphabetically and
 * numerically to help customers locate options quickly. The order of
 * filter groups is not modified here and should follow the configuration
 * set in Shopify’s Search & Discovery app. Custom client‑side filters
 * previously added (such as a dynamic Tire Brand filter) have been
 * removed in favor of native metafield filters configured via Search &
 * Discovery.
 */
(function () {
  function initFilterAdjustments() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return;

    // Helper to retrieve all filter <details> elements
    function getFilterDetails() {
      return Array.from(form.querySelectorAll('details.js-filter'));
    }

    // Rename “Brand” to “Wheel Brand” without reordering it
    function renameAndReorderBrandFilter() {
      var details = getFilterDetails();
      var brandDetail = null;
      details.forEach(function (det) {
        var labelEl = det.querySelector('summary .facets__summary-label');
        if (!labelEl) return;
        var text = labelEl.textContent.trim().toLowerCase();
        // Match either the default "brand" label or the updated "wheel brand"
        if (text === 'brand' || text === 'wheel brand') {
          brandDetail = det;
        }
      });
      if (brandDetail) {
        // Rename label to ensure consistency
        var labelSpan = brandDetail.querySelector('summary .facets__summary-label');
        if (labelSpan) {
          labelSpan.textContent = 'Wheel Brand';
        }
        // Do not reorder the filter; ordering should follow admin settings
      }
    }

    // Rename "Wheel Size" filter to "Wheel Diameter". This ensures that any
    // built‑in variant filter named "Wheel Size" aligns with the naming used
    // on packages. If the filter label already uses "Wheel Diameter", nothing
    // changes.
    function renameWheelSizeFilter() {
      var details = getFilterDetails();
      var sizeDetail = null;
      details.forEach(function (det) {
        var labelEl = det.querySelector('summary .facets__summary-label');
        if (!labelEl) return;
        var text = labelEl.textContent.trim().toLowerCase();
        if (text === 'wheel size') {
          sizeDetail = det;
        }
      });
      if (sizeDetail) {
        var labelSpan = sizeDetail.querySelector('summary .facets__summary-label');
        if (labelSpan) {
          labelSpan.textContent = 'Wheel Diameter';
        }
      }
    }

    // Previously we repositioned the Tire Brand filter relative to Tire Type. This
    // function is retained for backward compatibility but left empty so as
    // not to override the order specified in the Search & Discovery app.
    function reorderTireFilters() {
      // Intentionally no-op
    }

    // Sort the values within each filter alphabetically/numerically
    function sortFilterValues() {
      var details = getFilterDetails();
      details.forEach(function (det) {
        // Find the list of options within this filter
        var list = det.querySelector('ul');
        if (!list) return;
        var items = Array.from(list.children);
        if (!items.length) return;
        // Determine if items contain checkboxes (list elements with labels) or custom HTML
        items.sort(function (a, b) {
          var textA = a.textContent.trim();
          var textB = b.textContent.trim();
          // Attempt numeric sort if both strings start with a number
          var numA = parseFloat(textA);
          var numB = parseFloat(textB);
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          }
          return textA.localeCompare(textB, undefined, { numeric: true });
        });
        items.forEach(function (item) {
          list.appendChild(item);
        });
      });
    }

    renameAndReorderBrandFilter();
    renameWheelSizeFilter();
    reorderTireFilters();
    sortFilterValues();

    // The dynamic Tire Brand filter has been removed in favor of the metafield
    // filter configured via Search & Discovery. No custom filter is added here.
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initFilterAdjustments();
  } else {
    document.addEventListener('DOMContentLoaded', initFilterAdjustments);
  }
})();